const ContactForm = () => (
        <form id="contact" className="grid grid-cols-1 bg-white" action="https://usebasin.com/f/5edbb59268ca" method="POST" enctype="multipart/form-data" >
            <div className="grid grid-cols-1 lg:grid-cols-2 grid-rows-4 gap-4">
                <div className="inline-block" id="firstNameBlock">
                    <label htmlFor="firstName" className="requiredField">First Name</label>
                    <input type="text" name="firstName" className="w-full bg-base-200 p-1 text-[#2E4756]  mt-1 rounded focus:outline-none" required />
                </div>

                <div className="inline-block" id="lastNameBlock">
                    <label htmlFor="lastName" className="requiredField">Last Name</label>
                    <input type="text" name="lastName" className="w-full bg-base-200 p-1 text-[#2E4756]  mt-1 rounded focus:outline-none" required />
                </div>

                <div className="inline-block lg:col-span-2" id="emailBlock">
                    <label htmlFor="email" className="requiredField">Email</label>
                    <input type="email" name="email" className="w-full bg-base-200 p-1 text-[#2E4756]  mt-1 rounded focus:outline-none" required />
                </div>

             </div>
            
            <button className="btn btn-accent">Submit</button>
        </form>
)

export default ContactForm